"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateInput = void 0;
var React = require("react");
var moment = require("moment");
var services_1 = require("@falcon/services");
var DateInput = /** @class */ (function (_super) {
    __extends(DateInput, _super);
    function DateInput(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnDayChange = function (event) {
            var date = (event.target.validity.valid) ? event.target.value : _this.state.dateDay;
            _this.setState({ dateDay: date });
            _this.props.setParentState("".concat(_this.state.dateYear, "-").concat(_this.state.dateMonth, "-").concat(date));
            _this.props.executeNativeEvent && _this.props.executeNativeEvent(event);
        };
        _this.handleOnMonthChange = function (event) {
            var date = (event.target.validity.valid) ? event.target.value : _this.state.dateMonth;
            _this.setState({ dateMonth: date });
            _this.props.setParentState("".concat(_this.state.dateYear, "-").concat(date, "-").concat(_this.state.dateDay));
            _this.props.executeNativeEvent && _this.props.executeNativeEvent(event);
        };
        _this.handleOnYearChange = function (event) {
            var date = (event.target.validity.valid) ? event.target.value : _this.state.dateYear;
            _this.setState({ dateYear: date });
            _this.props.setParentState("".concat(date, "-").concat(_this.state.dateMonth, "-").concat(_this.state.dateDay));
            _this.props.executeNativeEvent && _this.props.executeNativeEvent(event);
        };
        _this.handleOnBlurEvent = function (event) {
            var customDate = "".concat(_this.state.dateYear, "-").concat(_this.state.dateMonth, "-").concat(_this.state.dateDay);
            var valueAsMoment = moment(customDate, moment.ISO_8601);
            var isValid = valueAsMoment.isValid();
            _this.setState({ isValid: isValid });
            _this.props.setParentState(customDate);
            _this.props.executeNativeEvent && _this.props.executeNativeEvent(event);
        };
        _this.handleLocalValidation = function () {
            var customDate = "".concat(_this.state.dateYear, "-").concat(_this.state.dateMonth, "-").concat(_this.state.dateDay);
            var valueAsMoment = moment(customDate, moment.ISO_8601);
            var isValid = valueAsMoment.isValid();
            _this.setState({ isValid: isValid });
        };
        var isValid;
        if (!_this.props.dateYear && !_this.props.dateMonth && !_this.props.dateDay) {
            // we shouldn't show validation message for unfilled questions on component load
            isValid = undefined;
        }
        else {
            var customDate = "".concat(_this.props.dateYear, "-").concat(_this.props.dateMonth, "-").concat(_this.props.dateDay);
            var valueAsMoment = moment(customDate, moment.ISO_8601);
            isValid = valueAsMoment.isValid();
        }
        _this.state = {
            dateDay: _this.props.dateDay,
            dateMonth: _this.props.dateMonth,
            dateYear: _this.props.dateYear,
            isValid: isValid
        };
        _this.handleOnBlurEvent = _this.handleOnBlurEvent.bind(_this);
        _this.toggleEventForNextButton = _this.toggleEventForNextButton.bind(_this);
        return _this;
    }
    DateInput.prototype.componentDidMount = function () {
        this.toggleEventForNextButton(true);
    };
    DateInput.prototype.componentWillUnmount = function () {
        this.toggleEventForNextButton(false);
    };
    DateInput.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if ((prevProps.dateDay !== this.props.dateDay && prevProps.dateMonth !== this.props.dateMonth && prevProps.dateYear !== this.props.dateYear) ||
            (this.props.changed && (prevProps.dateDay !== this.props.dateDay || prevProps.dateMonth !== this.props.dateMonth || prevProps.dateYear !== this.props.dateYear))) {
            this.setState({
                dateDay: this.props.dateDay,
                dateMonth: this.props.dateMonth,
                dateYear: this.props.dateYear
            });
        }
    };
    DateInput.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "customDate-container", role: "group", "aria-label": this.props.labelText, id: this.props.fieldName },
                React.createElement("div", null,
                    React.createElement("label", { className: "font-weight-light", htmlFor: "".concat(this.props.fieldName + "-day"), hidden: this.props.subTextDisabled },
                        this.props.dayText,
                        React.createElement("br", null)),
                    React.createElement("input", { type: "text", className: "form-control ".concat(this.getInputClassName(), " customDate-day"), value: this.state.dateDay, onChange: this.handleOnDayChange, onBlur: this.handleOnBlurEvent, placeholder: "DD", pattern: "[0-9]*", readOnly: this.props.isReadOnly, maxLength: 2, disabled: this.props.isDisabled, id: this.props.fieldName + "-day", "aria-label": "day" })),
                React.createElement("div", null,
                    React.createElement("label", { className: "font-weight-light", htmlFor: "".concat(this.props.fieldName + "-month"), hidden: this.props.subTextDisabled },
                        this.props.monthText,
                        React.createElement("br", null)),
                    React.createElement("input", { type: "text", className: "form-control ".concat(this.getInputClassName(), " customDate-month"), value: this.state.dateMonth, onChange: this.handleOnMonthChange, onBlur: this.handleOnBlurEvent, placeholder: "MM", pattern: "[0-9]*", readOnly: this.props.isReadOnly, maxLength: 2, disabled: this.props.isDisabled, id: this.props.fieldName + "-month", "aria-label": "month" })),
                React.createElement("div", null,
                    React.createElement("label", { className: "font-weight-light", htmlFor: "".concat(this.props.fieldName + "-year"), hidden: this.props.subTextDisabled },
                        this.props.yearText,
                        React.createElement("br", null)),
                    React.createElement("input", { type: "text", className: "form-control ".concat(this.getInputClassName(), " customDate-year"), value: this.state.dateYear, onChange: this.handleOnYearChange, onBlur: this.handleOnBlurEvent, placeholder: "YYYY", pattern: "[0-9]*", readOnly: this.props.isReadOnly, maxLength: 4, disabled: this.props.isDisabled, id: this.props.fieldName + "-year", "aria-label": "year" }))),
            !this.state.isValid && this.props.validationMessage && React.createElement("div", { className: "invalid-feedback d-block" }, this.props.validationMessage)));
    };
    DateInput.prototype.getInputClassName = function () {
        if (this.state.isValid == null) {
            return "";
        }
        else if (this.state.isValid === true) {
            return "is-valid";
        }
        else {
            return "is-invalid";
        }
    };
    ;
    DateInput.prototype.toggleEventForNextButton = function (add) {
        var nextButton = document.getElementById(services_1.NEXT_BUTTON_ID);
        if (nextButton) {
            if (add) {
                nextButton.addEventListener("click", this.handleLocalValidation);
            }
            else {
                nextButton.removeEventListener("click", this.handleLocalValidation);
            }
        }
    };
    return DateInput;
}(React.Component));
exports.DateInput = DateInput;
//# sourceMappingURL=DateInput.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/DateInput.js
// module id = 3624
// module chunks = 0